module.exports = __webpack_public_path__ + "img/06.b729ce18.png";